/**
 * useContextualAssistant — позволяет странице «перехватить» плавающую кнопку
 * AI-помощника (AssistantWidget, ✨ справа-внизу) под свой контекст.
 *
 * Зачем: на странице бота клик по общей ✨ открывал ОБЩИЙ AI-маркетолог (без
 * контекста бота), хотя рядом есть специализированный ботовый помощник
 * (BotAssistantChat). Страница регистрирует здесь свой обработчик — и виджет,
 * если обработчик есть, открывает контекстного помощника вместо общего.
 * Синглтон вне Pinia (как useToast/useConfirm).
 */
import { ref } from "vue";

export interface ContextualAssistant {
  /** Короткая подпись для тултипа кнопки (напр. «Помощник конструктора ботов»). */
  label: string;
  /** Открыть/переключить контекстного помощника (напр. раскрыть BotAssistantChat). */
  open: () => void;
}

const current = ref<ContextualAssistant | null>(null);

export function useContextualAssistant() {
  function register(a: ContextualAssistant): void {
    current.value = a;
  }
  function clear(): void {
    current.value = null;
  }
  return { current, register, clear };
}
